// extracted by mini-css-extract-plugin
export default {"referenceWrapper":"referenceWrapper--sAzim","wrapper":"wrapper--AZA93"};